var TemplateLibraryHeaderBackView;

TemplateLibraryHeaderBackView = Marionette.ItemView.extend( {
	template: '#tmpl-kitbuilder-template-library-header-back',

	id: 'kitbuilder-template-library-header-preview-back',

	events: {
		'click': 'onClick'
	},

	onClick: function() {
		kitbuilder.templates.showTemplates();
	}
} );

module.exports = TemplateLibraryHeaderBackView;
